import AnimatedSection from './AnimatedSection';

const FullDayBlock = () => {
  return (
    <section className="py-20 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Image */}
          <AnimatedSection direction="left">
            <div className="rounded-xl overflow-hidden shadow-xl border-2 border-amber/20">
              <img
                src="/images/jurassic-jack-dino-fun-collection-040.png"
                alt="Jurassic Jack full day event setup"
                className="w-full h-auto"
                loading="lazy"
              />
            </div>
          </AnimatedSection>

          {/* Content */}
          <AnimatedSection direction="right" delay={0.15}>
            <div className="space-y-6">
              <div className="inline-block">
                <span className="badge-danger text-sm">
                  ⚠ Not A Short Appearance
                </span>
              </div>

              <h2 className="text-4xl md:text-5xl font-display text-charcoal leading-tight">
                This Is Not A{' '}
                <span className="text-jp-red">20-Minute Show</span>
              </h2>

              <p className="text-lg text-charcoal/70 leading-relaxed">
                Jurassic Jack is designed as a full-day experience. We operate across daylight event hours with professional staff onsite, roaming and activating key areas — without competing with your core attractions.
              </p>

              <ul className="space-y-3">
                {[
                  'Integrated into the life of the showgrounds',
                  'Flexible scheduling across peak family times',
                  'Activation zones + roaming encounters',
                  'Designed for outdoor regional environments',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="w-5 h-5 rounded-full bg-jp-red/10 flex items-center justify-center shrink-0 mt-0.5">
                      <svg className="w-3 h-3 text-jp-red" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                      </svg>
                    </span>
                    <span className="text-charcoal/70">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default FullDayBlock;
